import React from "react";
import * as Filters from "@morningtrain/react-filters";
import {inject} from "@morningtrain/react-decorators";
import FlexBox from "layouts/page/FlexBox";

@inject(['operation'])
export default class OperationFilters extends React.Component {


    get availableFilters() {
        return this.operation.filtersWithType;
    }

    getDefaultFilters() {
        let filters = this.availableFilters;
        let keys = Object.keys(filters);
        return keys.map(key => {
            let filter = filters[key];
            let Filter = Filters[filter.type];
            if(!Filter) {
                return null;
            }

            let props = {...filter};
            delete props.type;

            return (
                <Filter constraint={key} {...props} key={key} />
            );
        }).filter(f => f);
    }

    renderFilters() {
        let {filters} = this.props;

        if(!filters) {
            filters = this.getDefaultFilters();
        }

        if(!filters || filters.length === 0) {
            return null;
        }

        return filters;
    }

    render() {
        return (
            <div className="flex mt-6 group space-x-2 sm:mt-0">
                {this.renderFilters()}
            </div>
        );
    }

}